export interface Replacement {
    start: number;
    end: number;
    replacement: string;
}

export default function replaceText(text: string, replacements: Replacement[]) {
    let result = text;
    const replacementsInOrder = Object.entries(replacements).sort((a, b) => b[1].start - a[1].start); // Sort replacements by starting index (descending)

    for (const [_idx, { start, end, replacement }] of replacementsInOrder) {
        // Adjust start and end indices based on previous replacements (considering replacement order)
        const adjustedStart = start;
        const adjustedEnd = end;

        // Perform replacement
        result = result.substring(0, adjustedStart) + replacement + result.substring(adjustedEnd);
    }

    return result;
}